import { TidyStorage } from 'src/shared/providers/tidy-storage';

export interface SecondaryPageContext<T = Record<string, any>> {
  /** True when rendered inside the desktop right-side panel; false on a full mobile page. */
  isRightSideContent: boolean;
  params: T;
}

/**
 * Secondary-layer pages receive params two ways: `dialog-params` in storage when
 * opened in the right-side panel, or router `history.state` on mobile. Merging both
 * lets a page read its inputs the same way in either layer.
 */
export async function readSecondaryPageContext<T = Record<string, any>>(storage: TidyStorage): Promise<SecondaryPageContext<T>> {
  const isRightSideContent = (await storage.retrieve('dialog-right-side-open')) || false;
  const dialogParams = isRightSideContent ? (await storage.retrieve('dialog-params')) || {} : {};
  const routeState = (typeof history !== 'undefined' && history.state) || {};
  return { isRightSideContent, params: { ...routeState, ...dialogParams } as T };
}

export function toIsoDate(value: Date | string | null | undefined): string | null {
  if (!value) { return null; }
  if (value instanceof Date) {
    const year = value.getFullYear();
    const month = String(value.getMonth() + 1).padStart(2, '0');
    const day = String(value.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }
  return String(value).slice(0, 10);
}
